(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maytrix-factory-floor"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const feed=root.querySelector('.mx-factory-feed'),cards=[...root.querySelectorAll('button.mx-factory-open')],prev=root.querySelector('[data-feed-prev]'),next=root.querySelector('[data-feed-next]');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const state=()=>{prev.disabled=feed.scrollLeft<2;next.disabled=feed.scrollLeft>=feed.scrollWidth-feed.clientWidth-2};
  const move=d=>feed.scrollBy({left:d*((feed.querySelector('article')?.getBoundingClientRect().width||300)+parseFloat(getComputedStyle(feed).gap)),behavior:reduced?'instant':'smooth'});
  prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));feed.addEventListener('scroll',state,{passive:true});
  const resize=new ResizeObserver(state);resize.observe(feed);state();
  feed.addEventListener('keydown',e=>{if(e.target===feed&&(e.key==='ArrowLeft'||e.key==='ArrowRight')){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});
  const setPlaying=(card,playing)=>{card.classList.toggle('is-playing',playing);card.setAttribute('aria-pressed',String(playing));card.setAttribute('aria-label',(playing?'Pause ':'Play ')+card.dataset.title+' factory project')};
  const pauseCard=card=>{card.dataset.playRequested='false';card.querySelector('video')?.pause();setPlaying(card,false)};
  const pauseAll=()=>cards.forEach(pauseCard);
  cards.forEach(card=>card.addEventListener('click',()=>{
    if(card.dataset.playRequested==='true'){pauseCard(card);return}
    cards.filter(other=>other!==card).forEach(pauseCard);
    let video=card.querySelector('video');
    if(!video){
      video=document.createElement('video');video.controls=false;video.muted=true;video.defaultMuted=true;video.playsInline=true;video.preload='none';video.poster=card.dataset.poster;
      video.setAttribute('playsinline','');video.setAttribute('webkit-playsinline','');video.setAttribute('disablepictureinpicture','');video.setAttribute('aria-hidden','true');video.tabIndex=-1;video.src=card.dataset.src;
      video.addEventListener('playing',()=>{if(card.dataset.playRequested!=='true'){video.pause();return}setPlaying(card,true)});
      video.addEventListener('pause',()=>setPlaying(card,false));
      video.addEventListener('ended',()=>pauseCard(card));
      video.addEventListener('error',()=>{pauseCard(card);video.remove()});
      card.append(video);
    }
    card.dataset.playRequested='true';
    video.play().catch(()=>{if(video.paused)pauseCard(card)});
  }));
  const visibility=()=>{if(document.hidden)pauseAll()};document.addEventListener('visibilitychange',visibility);
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.intersectionRatio<.15)pauseCard(entry.target)}),{threshold:[0,.15]});cards.forEach(card=>observer.observe(card));
  const unload=e=>{if(e.target.contains(root)){pauseAll();observer.disconnect();resize.disconnect();document.removeEventListener('visibilitychange',visibility);document.removeEventListener('shopify:section:unload',unload)}};document.addEventListener('shopify:section:unload',unload);
 }
 document.querySelectorAll('[data-factory-feed]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-factory-feed]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
